import { render, staticRenderFns } from "./BrowserRuleEdit.vue?vue&type=template&id=12813a52&scoped=true"
import script from "./BrowserRuleEdit.vue?vue&type=script&lang=ts"
export * from "./BrowserRuleEdit.vue?vue&type=script&lang=ts"
import style0 from "./BrowserRuleEdit.vue?vue&type=style&index=0&id=12813a52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12813a52",
  null
  
)

export default component.exports